import { render, staticRenderFns } from "./InterestCategoriesView.vue?vue&type=template&id=135e46d7&"
import script from "./InterestCategoriesView.vue?vue&type=script&lang=ts&"
export * from "./InterestCategoriesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports